<template>
  <v-card flat class="px-1 mt-1">
    <v-card-text class="pa-0">
    <h3 class="pa-1 pl-2">{{$t('message.projects.project')}}: <router-link :to="`/projects/${projectId}`">{{ projectFullName }}</router-link>
    </h3>
    </v-card-text>
    <compact-list :payload="payload" :key="reInit"></compact-list>
    <div ref="lgContainer" style="display:none"></div>
  </v-card>
</template>
<script>
import { hostAppApi } from '@/plugins/axios_settings'
import { mapGetters } from 'vuex'
import DocumentGalleryMixin from '@/mixins/documentGallery'
export default {
  mixins: [DocumentGalleryMixin],
  data () {
    return {
      payload: {
        moduleTitle: 'message.layout.weldlog',
        addBtnTo: '',
        pagination: {},
        totalCount: 0,
        perPage: 6,
        loading: false,
        editHandler: null,
        actionSize: '1', // for delete action
        list: [],
        itemHeaders: [{
          cols: 4,
          labels: [
            'message.projectFeature.drawingNumber'
          ]
        },
        {
          cols: 2,
          labels: [
            'message.projectFeature.weldNumber'
          ]
        },
        {
          cols: 2,
          labels: [
            'message.projectFeature.weldingID'
          ]
        },
        {
          cols: 3,
          labels: [
            'message.projects.status'
          ]
        }, { cols: 1 }],
        items: [{
          value: 'drawing_nr',
          class: 'pa-0 pa-1 text-justify',
          cols: '4',
          spanClass: 'body pl-2',
          isParagraph: true
        },
        {
          value: 'weld_nr',
          class: 'pa-0 pa-1 text-justify',
          cols: '2',
          spanClass: 'body pl-2',
          isParagraph: true
        },
        {
          value: 'welding_id',
          class: 'pa-0 pa-1 text-justify',
          cols: '2',
          spanClass: 'body pl-2',
          isParagraph: true
        },
        {
          value: '',
          cols: '3',
          class: 'pa-0',
          rowClass: 'mt-1',
          subItems: [{
            value: 'is_completed',
            class: 'pa-0',
            cols: '12',
            spanClass: 'body'
          }]
        }],
        storeIndex: 'PROJECT_WELDLOG_INDEX',
        isLivePagination: true,
        hasDelete: true,
        hasNoNext: true
      },
      MODULE: 'projectweldlog',
      loading: false,
      reInit: 0,
      pagination: !this.$formatter.isEmptyObject(this.$store.state.common.PROJECT_WELDLOG_INDEX) ? this.$store.state.common.PROJECT_WELDLOG_INDEX : { itemsPerPage: 6, page: 1 },
      /* project weldlog */
      projectId: parseInt(this.$route.params.project_id),
      hostUserId: this.$cookie.get(process.env.VUE_APP_HOST_USER) ? this.$cookie.get(process.env.VUE_APP_HOST_USER) : 0,
      projectFullName: ''
    }
  },
  components: {
    'compact-list': () => import('@/components/CompactList.vue')
  },
  created () {
    // `items` lives in data(), where `this` has no methods yet — wire the
    // document preview icon on the drawing-nr column here instead.
    Object.assign(this.payload.items[0], {
      spanClass: 'body pl-2 scroll-list-first-col',
      prefixIcon: 'mdi-image-multiple',
      prefixIconSize: 32,
      prefixIconClick: this.previewDocuments,
      prefixIconCondition: this.hasDocuments
    })
    this.payload.editHandler = (item) => {
      this.$router.push(`/projects/${this.projectId}/weld-log/action/${item.id}`)
    }
    this.payload.addBtnTo = `/projects/${this.projectId}/weld-log/action`
  },
  mounted () {
    this.payload.module = this.MODULE
    this.getListHandler()
    const text = 'message.common.deleteSuccess'
    this.$eventBus.$on('deleteItems', (data) => {
      if (data.module === this.MODULE) {
        const payload = { url: `project_weldlog/${data.id}?user_id=${parseInt(this.hostUserId)}&project_id=${this.projectId}`, isSingle: true, module: this.MODULE, fromHostApi: true }
        this.$store.commit('showDeleteDialog', payload)
      }
    })
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.MODULE) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getListHandler(this.pagination)
      }
    })
    // Load list on page
    this.$eventBus.$on('loadList', (data) => {
      this.getListHandler(data)
    })
  },
  methods: {
    documentEditUrl (item) {
      return `${this.getHostRefApi}project_weldlog/${item.id}/edit?user_id=${this.hostUserId}&project_id=${this.projectId}`
    },
    documentsKey () {
      return 'weldlog_documents'
    },
    getListHandler (paginationObj) {
      const pagination = paginationObj || this.pagination
      this.payload.pagination.page = pagination.page
      this.payload.loading = true
      this.payload.module = this.MODULE
      const search = pagination.search ? pagination.search : ''
      const pageVal = pagination.page // search ? 1 : pagination.page
      const model = {
        start: ((pageVal - 1) * this.pagination.itemsPerPage),
        length: this.pagination.itemsPerPage,
        search: search
      }
      let url = `${this.getHostRefApi}project_weldlog?only_items=1&start=${model.start}&length=${model.length}`
      if (search) url += `&search=${search}`
      url += `&project_id=${this.projectId}`
      hostAppApi.get(url)
        .then(response => {
          let { data, recordsFiltered, projectFullName } = response.data
          this.payload.total = recordsFiltered
          const totalCount = Math.ceil(recordsFiltered / pagination.itemsPerPage)
          if (pagination.page === totalCount) this.payload.hasNoNext = true
          else this.payload.hasNoNext = false
          const transformData = {
            date: { list: ['weld_end'], from: 'YYYY-MM-DD', to: 'DD.MM.YYYY' }
          }
          data = this.$formatter.formatListModel(data, transformData)
          this.payload.list = data
          this.projectFullName = projectFullName
          if (this.reInit === 0) this.reInit++
        }).finally(() => {
          this.payload.loading = false
        })
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('deleteItems')
    this.$eventBus.$off('loadList')
  },
  computed: {
    ...mapGetters(['getHostRefApi'])
  }
}
</script>
